export default "__VITE_ASSET__Bwhn98lM__"